export enum DeleteTooltips {
  LinkedToTheOpenEncounter = "Condition is linked to the current consult",
  HasAClaimNumber = "A claim number has been set",
  LinkedToABilledVisit = "There are invoiced consults linked to this condition",
  RelatedToCalendarEvents = "There are appointments linked to this condition",
  RelatedConsults = "There are consults linked to this condition",
  OpenEncounter = "There is a consult in progress with {ProviderFullName}",
  OtherReason = "Unable to delete this condition"
}
